import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import * as route from '@/shared/constants/router';

export function usePageTitle() {
    const { t } = useTranslation();

    const { pathname } = useLocation();

    return useMemo(() => {
        switch (true) {
            case pathname === route.getDashboardPath():
                return t('dashboardPageTitle');
            case pathname === route.getTradingJournalPath():
                return t('tradingJournalPageTitle');
            case pathname === route.getTradingJournalAgentPath():
                return t('tradingJournalAgentPageTitle');
            case pathname === route.getProfileManagementPath():
                return t('profileManagementPageTitle');
            case pathname === route.getAffiliatePath():
                return t('affiliatePageTitle');
            case pathname === route.getPatternStudioOverviewPath():
            case pathname === route.getPatternStudioLivePath():
            case pathname === route.getPatternStudioLabPath():
                return t('patternStudioPageTitle');
            case pathname === route.getLotSizeCalculatorPath():
                return t('classicToolsPageTitle');
            default:
                return '';
        }
    }, [pathname, t]);
}
